/** */
import {
  ADD_MANY_SMS_TO_STORE,
  ADD_ONE_SMS_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_SMS_TO_STORE,
  REM_ONE_SMS_FROM_STORE
} from '../actions/sms';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_SMS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (messages, message) => ({
            ...messages,
            [message.id]: message
          }),
          {}
        )
      };
    case ADD_ONE_SMS_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (messages, message) => ({
            ...messages,
            [message.id]: message
          }),
          {}
        )
      };
    case LOAD_SMS_TO_STORE:
      return {
        ...payload.reduce(
          (messages, message) => ({
            ...messages,
            [message.id]: message
          }),
          {}
        )
      };
    case REM_ONE_SMS_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
